
import { defineComponent } from "vue";
import firebase from "firebase/app";
import Button from "@/components/Button.vue";
import TextInput from "@/components/TextInput.vue";
import FormSection from "./FormSection.vue";

let customerDataUnsub: Function;

const ONE_GB = 1000000000;
const FIREBASE_URL =
  process.env.VUE_APP_ENDPOINTS === "production"
    ? "https://console.firebase.google.com/u/0/project/samply-a03ff"
    : "https://console.firebase.google.com/u/0/project/samply-dev";

export default defineComponent({
  components: {
    Button,
    FormSection,
    TextInput
  },
  data() {
    return {
      /** True after the onAuthStateChanged has fired for the first time */
      authStateKnown: false,
      /** User is a Samply administrator */
      isAdmin: false,
      /** User object for the admin */
      admin: null as null | firebase.User,
      /** Email of the customer being searched for */
      customer: null as null | firebase.User,
      customerEmail: "",
      customerLoading: false,
      customerQuotas: {
        /** Storage quota converted to Gigabytes */
        storage: 0,
        /** Number of projects alloted to the customer */
        projects: 0,
        /** Number of collaborators  */
        projectCollaborators: 0
      },
      customerProjects: undefined,
      customerSharedProjects: undefined,
      fbURL: FIREBASE_URL
    };
  },
  computed: {
    numberOfProjects(): number {
      return Object.keys(this.customerProjects || {}).length;
    },
    numberOfSharedProjects(): number {
      return Object.keys(this.customerSharedProjects || {}).length;
    }
  },
  methods: {
    async copy(text: string) {
      await navigator.clipboard.writeText(text);
    },
    async saveCustomerData() {
      this.customerLoading = true;
      await firebase
        .firestore()
        .collection("users")
        .doc(this.customer?.uid)
        .collection("product_data")
        .doc("colab")
        .update({
          storageQuota: this.customerQuotas.storage * ONE_GB ?? null,
          projectQuota: this.customerQuotas.projects ?? null,
          projectCollaboratorQuota:
            this.customerQuotas.projectCollaborators ?? null
        });
      this.customerLoading = false;
    },
    async fetchCustomerData() {
      const { uid } = this.customer || {};
      const userRef = firebase
        .firestore()
        .collection("users")
        .doc(uid)
        .collection("product_data")
        .doc("colab");
      if (customerDataUnsub) customerDataUnsub();
      customerDataUnsub = userRef.onSnapshot(snap => {
        const productData = snap.data();
        // Extract data
        this.customerQuotas.storage = productData?.storageQuota / ONE_GB ?? 0;
        this.customerQuotas.projects = productData?.projectQuota ?? 0;
        this.customerQuotas.projectCollaborators =
          productData?.projectCollaboratorQuota ?? 0;
        this.customerProjects = productData?.projects;
        this.customerSharedProjects = productData?.sharedProjects;
      });
      this.customerLoading = false;
    },
    async lookupCustomer() {
      this.customerLoading = true;
      const fn = firebase.functions().httpsCallable("getUserAuthRecordByEmail");
      const resp = await fn({ userEmail: this.customerEmail });
      const user = resp.data;
      if (user.non_existent_user) {
        this.customerLoading = false;
        console.error("Not a Samply user.");
      } else {
        this.customer = user;
        this.fetchCustomerData();
      }
    }
  }
});
